export default __webpack_public_path__ + "static/ameninaeopote-b0299dc60f5f03c2a9d296db08abf887.jpg";